/* eslint-disable react/prop-types */
import { TableCell, TableRow } from '@mui/material'
import React from 'react'
import fixTableCellWidth from 'utils/fixTableCellWidth'

export default function MinimalTableHeader() {
  return (
    <TableRow>
      <TableCell className="tablecell" style={fixTableCellWidth("150px")}>قلک</TableCell>
      <TableCell className="tablecell" style={fixTableCellWidth("150px")}>فرصت سرمایه گذاری</TableCell>
      <TableCell className="tablecell" style={fixTableCellWidth("170px")}>میانگین موجودی قلک</TableCell>
      <TableCell className="tablecell" style={fixTableCellWidth("170px")}>میانگین موجودی فرصت</TableCell>
      <TableCell className="tablecell" style={fixTableCellWidth("150px")}>مجموع سود</TableCell>
      <TableCell className="tablecell" style={fixTableCellWidth("150px")}>عملیات</TableCell>
    </TableRow>
  )
}
